//# sourceMappingURL=ds.mjs.map
/// <reference types="./ds.d.mts" />
import * as $redraw from "../redraw/redraw.mjs";
import * as $sketch from "../sketch/sketch.mjs";
import * as $sr from "../sketch_redraw/sketch/redraw.mjs";
import * as $keyframes from "./ds/css/keyframes.mjs";
import * as $modal from "./ds/providers/modal.mjs";
import * as $popover from "./ds/providers/popover.mjs";
import * as $scroll from "./ds/providers/scroll.mjs";
import { toList } from "./gleam.mjs";

function sketch_setup() {
  return $sr.initialise_cache(
    (stylesheet) => {
      let _pipe = stylesheet;
      let _pipe$1 = ((_capture) => {
        return $sketch.at_rule($keyframes.wave(), _capture);
      })(_pipe);
      let _pipe$2 = ((_capture) => {
        return $sketch.at_rule($keyframes.pulse(), _capture);
      })(_pipe$1);
      let _pipe$3 = ((_capture) => {
        return $sketch.at_rule($keyframes.fading_text(), _capture);
      })(_pipe$2);
      let _pipe$4 = ((_capture) => {
        return $sketch.at_rule($keyframes.dot_appear(), _capture);
      })(_pipe$3);
      let _pipe$5 = ((_capture) => {
        return $sketch.at_rule($keyframes.text_appear(), _capture);
      })(_pipe$4);
      let _pipe$6 = ((_capture) => {
        return $sketch.at_rule($keyframes.text_gradient(), _capture);
      })(_pipe$5);
      let _pipe$7 = ((_capture) => {
        return $sketch.at_rule($keyframes.spin(), _capture);
      })(_pipe$6);
      let _pipe$8 = ((_capture) => {
        return $sketch.at_rule($keyframes.bell_rock(), _capture);
      })(_pipe$7);
      let _pipe$9 = ((_capture) => {
        return $sketch.at_rule($keyframes.z_drift(), _capture);
      })(_pipe$8);
      return ((_capture) => {
        return $sketch.at_rule($keyframes.ring_pulse(), _capture);
      })(_pipe$9);
    },
  );
}

/**
 * Initialise the cache, and returns the rendering provider function.
 * Just like any components, `init` is a component-creator that will
 * correctly generate the cache and the required providers, and provide
 * the correct rendering function.
 *
 * ```gleam
 * pub fn main() {
 *   let ds_provider = ds.init()
 *   let assert Ok(root) = client.create_root("#app")
 *   client.render(root, {
 *     react.strict_mode([
 *       ds_provider([
 *         // Components goes here. The ds_provider function will not add
 *         // any visible nodes in the DOM.
 *       ])
 *     ])
 *   })
 * }
 * ```
 */
export function init() {
  return $redraw.compose(
    $scroll.provider(),
    (scroll_provider) => {
      return $redraw.compose(
        $popover.provider(),
        (popover_provider) => {
          return $redraw.compose(
            $modal.provider(),
            (modal_provider) => {
              return $redraw.component_(
                "Freyja",
                (children) => {
                  let cache = sketch_setup();
                  return $sr.provider(
                    cache,
                    toList([
                      scroll_provider(
                        toList([
                          popover_provider(toList([modal_provider(children)])),
                        ]),
                      ),
                    ]),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
